import React, { useState, useEffect,useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from "react-bootstrap";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import "./css/school-contact.css"; 
import axiosOrganizationInstance from "./AxiosOrganizationInstance"; 
import { UserContext } from "../context/UserContext";

function OrganizationContact() {
    const {organizationName} = useContext(UserContext)
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [authToken, setAuthToken] = useState(true);
  const [organizationId, setorganizationId] = useState(null);
      const navigate= useNavigate()
  const [contact, setContact] = useState({
    name: "",
    email: "",
    contactNumber: "",
    status: "ACTIVE",
    password: "",
    organizationId:null,
    roleId:null,
    roleName:'',
    organizationName:"",
    roleName:"",
    createdById:null,
    updatedById:null,

  });

  useEffect(() => {
    const organizationId = localStorage.getItem("organizationId");
   
   
    if (organizationId) {
      setorganizationId(organizationId)
      fetchContacts(organizationId);
    }
  }, [organizationId]);

  useEffect(() => {
      const token = localStorage.getItem("Token");
      console.log('token', token)
      setAuthToken(token);
  
      if (authToken===false) {
        navigate("/organization/signin"); // Redirect if no token is found
      }
    }, [authToken]);

  const fetchContacts = async () => {
    console.log('user organization Id', organizationId)
    try {
      const token = localStorage.getItem("Token");
      const response = await axiosOrganizationInstance.get(`/organization-user/${organizationId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
        },
      });
      setContacts(response.data.users);
      
      
      console.log('user Data', response.data)
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
console.log('Contacts', contacts)

  const handleContactSubmit = async (e) => {
    e.preventDefault();
   
   
    try {
      let response;
      console.log('Selected Person', selectedContact)
      if (isEditing && selectedContact) {
        const token = localStorage.getItem("Token");
        response = await axiosOrganizationInstance.put(
          `/organization-user/${selectedContact.organizationUserId}`,
          contact,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
      } else {
        const token = localStorage.getItem("Token");
        contact.createdById= localStorage.getItem("userId")
        contact.updatedById= localStorage.getItem("userId")
        contact.organizationId= localStorage.getItem("organizationId")
        contact.organizationName =localStorage.getItem("organizationName")
       

        console.log('Data',contact)
       
        response = await axiosOrganizationInstance.post(`/organization-user`,
          contact,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
            },
          }
        );
      }

      if (response.status === 200 || response.status === 201) {
        const updatedContact = response.data;
        if (isEditing) {
          setContacts((prevContacts) =>
            prevContacts.map((cnt) =>
              cnt.user_id === selectedContact.user_id ? updatedContact : cnt
            )
          );
          alert("user updated successfully!");
        } else {
          setContacts((prevContacts) => [...prevContacts, updatedContact]);
          alert("Contact added successfully!");
        }
      } else {
        alert(`Failed to submit contact: ${response.statusText}`);
      }
      fetchContacts();
    } catch (error) {
      console.error("Error submitting contact:", error);
      alert(
        `Error submitting contact: ${
          error.response?.data?.message || error.message
        }`
      );
    }
    resetForm();
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;

    setContact((prevContact) => ({
      ...prevContact,
      [name]: value,
    }));
  };

  const handleContactType = (e)=>{
  
  const selectedValue = e.target.value;
  const selectedLabel = e.target.options[e.target.selectedIndex].text;
  // console.log('2',selectedLabel)
  // contact.roleId=selectedValue;
  // contact.roleName=selectedLabel;
  setContact((prevContact)=>({...prevContact,roleId:selectedValue,roleName:selectedLabel}))
  }

  

  const handleSelectContact = (organizationUserId) => {
    console.log('contact data',organizationUserId)
  
    const contactToEdit = contacts.find((cnt) => cnt.organizationUserId === organizationUserId);
    console.log('contact To Edit', contactToEdit)
    if (contactToEdit) {
      setContact(contactToEdit);
      
      setSelectedContact(contactToEdit);
      setIsEditing(true);
      setIsFormVisible(true);
    }
  };

  const handleDeleteContact = async (personId) => {
    console.log('Person Id',personId)
    if (window.confirm("Are you sure you want to delete this contact?")) {
      try {
        const token = localStorage.getItem("Token");
        await axiosOrganizationInstance.delete(`/organization-user/${personId}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Set the token in the 'Authorization' header
          },
        });
        setContacts((prevContacts) =>
          prevContacts.filter((cnt) => cnt.organizationUserId !== personId)
        );
        alert("Contact deleted successfully!");
      } catch (error) {
        console.error("Error deleting contact:", error);
        alert("Error deleting contact. Please check the console for details.");
      }
    }
  };

  const handleAddNewContact = () => {
    resetForm();
    setIsFormVisible(true);
  };

  const resetForm = () => {
    setContact({
      name: "",
    email: "",
    contactNumber: "",
    status: "ACTIVE",
    password: "",
    roleId:null,
    roleName:"",
    
    });
    setIsEditing(false);
    setSelectedContact(null);
    setIsFormVisible(false);
  };

  return (
    <div className="mt-5" style={{marginLeft:'30px'}}>
      <div
        className="d-flex justify-content-between align-items-center mb-4"
        style={{ borderBottom: "1px solid #D1D1D6", paddingBottom: "10px" }}
      >
        <p style={{ fontSize: "24px", fontWeight: "700" }}>Contact Details</p>
        

        <Button
          variant="outline-dark"
          onClick={(e) => {
            e.preventDefault();
            handleAddNewContact();
          }}
          className="me-2"
          style={{
            width: "90px",
            backgroundColor: "#FFFEF0",
            border: "1px solid #0976A1",
            color: "#017EF3",
          }}
        >
          New
        </Button>
      </div>

      <Row>
        {contacts.length>0&&(
 <Col lg={12} className="mb-4">
 <div
   className="ag-theme-quartz"
   style={{ height: 400, width: "100%" }}
 >
   <AgGridReact
     columnDefs={[
       {
         headerName: "Contact Name",
         field: "name",
         suppressMovable: true,
         width: "220",
       },
       {
         headerName: "Email",
         field: "email",
         suppressMovable: true,
         width: "220",
       },
       {
         headerName: "Phone Number",
         field: "contactNumber",
         suppressMovable: true,
         width: "160",
       },
       {
         headerName: "Contact Type",
         field: "roleName",
         suppressMovable: true,
         width: "140",
       },
       {
         headerName: "Status",
         field: "status",
         suppressMovable: true,
         width: "100",
       },
       {
         headerName: "Actions",
         width: "110",
         cellRenderer: (params) => {
           return (
             isEditing === false && (
               <div
                 className="d-flex justify-content-center align-items-center"
                 style={{ marginTop: "12px" }}
               >
                 <CiEdit
                  style={{
                   fontSize: "24px",
                   color: "#017EF3",
                   cursor: "pointer",
                 }}
                   onClick={() =>
                     handleSelectContact(params.data.organizationUserId)
                   }
                 />

                 <MdOutlineDeleteOutline
                 style={{
                   marginLeft: "20px",
                   color: "#FF3B30",
                   cursor: "pointer",
                   fontSize: "24px",
                  
                 }}
                   onClick={() =>
                     handleDeleteContact(params.data.organizationUserId)
                   }
                 />
               </div>
             )
           );
         },
         suppressMovable: true,
       },
     ]}
     rowData={contacts}
     pagination={false}
     paginationPageSize={10}
     domLayout="autoHeight"
   />
 </div>
</Col>
        )}
       

        {isFormVisible && (
          <Col lg={12} className="mb-4" style={{ marginTop: "-200px" }}>
            <div className="card shadow-box" style={{ border: "none" }}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="text-center">
                    {isEditing ? "Edit Contact" : "Add New Contact"}
                  </h5>
                </div>
                <hr />
                <Form onSubmit={handleContactSubmit} className="contact-form">
                  <Row>
                    
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Person Name
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="text"
                          name="name"
                          value={contact.name}
                          onChange={handleContactChange}
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Email
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="email"
                          name="email"
                          value={contact.email}
                          onChange={handleContactChange}
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Phone Number
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="tel"
                          name="contactNumber"
                          value={contact.contactNumber}
                          onChange={handleContactChange}
                          required
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Contact Type
                          </Form.Label>
                        </div>
                        <Form.Select
                          name="contactType"
                          value={contact.roleId}
                          onChange={handleContactType}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        >
                          <option value=''>Select Contact Type</option>
                          <option value='1'>ADMIN</option>
                          <option value='2'>SUPERVISOR</option>
                          <option value='5'>TEACHER</option>
                          <option value='6'>AAYA</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Status
                          </Form.Label>
                        </div>
                        <Form.Control
                          as="select"
                          name="status"
                          value={contact.status}
                          onChange={handleContactChange}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        >
                          <option value="ACTIVE">Active</option>
                          <option value="INACTIVE">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              color: "#323E4F",
                            }}
                          >
                            Password
                          </Form.Label>
                        </div>
                        <Form.Control
                          type="password"
                          name="password"
                          value={contact.password}
                          onChange={handleContactChange}
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            color: "#697483",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="outline-dark"
                      type="submit"
                      style={{
                        width: "120px",
                        backgroundColor: "#FFFEF0",
                        border: "1px solid #0976A1",
                        color: "#017EF3",
                        marginRight: "10px",
                      }}
                    >
                      {isEditing ? "Save" : "Add Contact"}
                    </Button>
                    <Button
                    variant="outline-secondary"
                    onClick={resetForm}
                    style={{
                      width: "120px",
                      backgroundColor: "#FFFEF0",
                      border: "1px solid #017EF3",
                      color: "#017EF3",
                    }}
                  >
                    Cancel
                  </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default OrganizationContact;
